import React from 'react';
import PropTypes from 'prop-types';

// TODO: Extract this
export const noClockSports = [
  4000, // Badminton
  433100, // Baseball
  1250, // BeachVolleyball
  3400, // Bowls
  364800, // Boxing
  17500, // Cricket
  965300, // Darts
  967500, // NineBallPool
  105700, // OtherSports
  364700, // Snooker
  96610, // Speedway
  950, // Squash
  650, // TableTennis
  600, // Tennis
  601601, // ThreeByThreeBasketball
  1200, // Volleyball
  400, // Golf
];
// ----------------------------

const ClockView = ({ sportId, clock }) => {
  const showClock = !noClockSports.includes(sportId)
    && !(clock === '00:00');

  return (
    <span className="inply-coupon-clock">
      { showClock && clock }
    </span>
  );
};

ClockView.propTypes = {
  sportId: PropTypes.number.isRequired,
  clock: PropTypes.string.isRequired,
};

export default ClockView;
